import { Type, Unit } from "@/commons/services/SendDocuments";

/**
 * ### S3ファイル格納場所リクエスト
 */
export interface S3LocationRequest {
  /** S3のURL作成種別 */
  type: S3LocationType;
  /**
   * ファイル数
   * ファイル名が複数ある場合は連番にする必要があるので、欲しいUrl数を渡す
   */
  count: number;
  /** 拡張子配列 */
  extensions: Array<string>;
  /** アップロード種別毎のパラメータ */
  params: S3LocationCareimage | S3LocationPicure | S3LocationMessage | S3LocationReceiveMessage | S3LocationOtherUserReceiveMessage | S3LocationWaiterReceiveMessage;
  /** 公開設定 */
  acl?: string;
}

/**
 * ### S3ファイルアップロードレスポンス
 */
export interface S3LocationResponse {
  /** ファイル格納先URL */
  url: string;
  /** ファイル格納用パラメータ */
  fields: {
    /**
     * フォームデータとして設定するシグネチャ等の情報
     * ファイルの種別毎に増減するため、key数は不定
     */
    [key: string]: string;
  };
}

/**
 * S3URL作成種別
 */
export enum S3LocationType {
  /** 介護記録 */
  CAREIMAGE = 0,
  /** 写真送付 */
  PICTURE = 1,
  /** イベント */
  EVENT = 2,
  /** 施設 */
  FACILITY = 3,
  /** メッセージ送信 */
  MESSAGE = 4,
  /** メッセージ下書き */
  DRAFT_MESSAGE = 5,
  /** 文書送付 */
  SEND_DOCUMENT = 6,
  /** 入居申込みテンプレート */
  ADMISSION_APPLICATION = 7,
  /** 入居判定テンプレート */
  ADMISSION_JUDGEMENT = 8,
  /** 入所者募集ページ(画像・動画) */
  WAITER_RECRUITMENT_MEDIA = 9,
  /** 入所者募集ページ(資料) */
  WAITER_RECRUITMENT_DOCUMENT = 10,
  /** フォロワーメッセージ送信 */
  FOLLOWER_MESSAGE = 11,
  /** 入所者募集ページ(ヘッダー画像) */
  WAITER_RECRUITMENT_HEADERIMAGE = 12,
  /** 家族からの連絡（受信メッセージ） */
  RECEIVE_MESSAGES = 13,
  /** 施設関係者からの連絡（受信メッセージ） */
  OTHER_USER_RECEIVE_MESSAGES = 14,
  /** 入所申込者からの連絡（受信メッセージ） */
  WAITER_RECEIVE_MESSAGES = 15,
  /** 他事業所メッセージ */
  OTHER_OFFICE_MESSAGES = 16,
  /** アンケート添付ファイル */
  QUESTIONNAIRE = 17
}

/**
 * S3URL作成 介護記録時のパラメータ
 */
export interface S3LocationCareimage {
  /** 利用者ID */
  residentId: number;
  /** 介護記録の日付 */
  datetime: number;
}

/**
 * S3URL作成 写真時のパラメータ
 */
export interface S3LocationPicure {
  /** 利用者ID */
  residentId: number;
}

/**
 * S3URL作成 メッセージ送信時のパラメータ
 */
export interface S3LocationMessage {
  /** ユーザーID */
  userId: string;
}

/**
 * S3URL作成 文書送付時のパラメータ
 */
export interface S3LocationSendDocument {
  /** ソートキー */
  sortKey: string;
  /** 種別 */
  type: Type;
  /** 文書単位 */
  unit: Unit;
}

/**
 * S3URL作成 家族からの連絡（受信メッセージ）時のパラメータ
 */
export interface S3LocationReceiveMessage {
  /** 利用者ID */
  residentId: number;
  /** 利用者ID */
  familyId: number;
}

/**
 * S3URL作成 施設関係者からの連絡（受信メッセージ）時のパラメータ
 */
export interface S3LocationOtherUserReceiveMessage {
  /** 施設関係者グループID */
  otherUserGroupId: number;
  /** メンバーID */
  memberId: number;
}

/**
 * S3URL作成 入所申込者からの連絡（受信メッセージ）時のパラメータ
 */
export interface S3LocationWaiterReceiveMessage {
  /** 利用者ID */
  residentId: number;
  /** 利用者ID */
  familyId: number;
}
